// extracted by mini-css-extract-plugin
export default {"root":"StatisticCard_root__43OKk","value":"StatisticCard_value__y-ACI"};